import { useState } from "react";

const TimeDropdown = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  const times = [
    "12:00 AM",
    "12:30 AM",
    "1:00 AM",
    "1:30 AM",
    "2:00 AM",
    "2:30 AM",
    "3:00 AM",
    "3:30 AM",
    "4:00 AM",
    "4:30 AM",
    "5:00 AM",
    "5:30 AM",
    "6:00 AM",
    "6:30 AM",
    "7:00 AM",
    "7:30 AM",
    "8:00 AM",
    "8:30 AM",
    "9:00 AM",
    "9:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "1:00 PM",
    "1:30 PM",
    "2:00 PM",
    "2:30 PM",
    "3:00 PM",
    "3:30 PM",
    "4:00 PM",
    "4:30 PM",
    "5:00 PM",
    "5:30 PM",
    "6:00 PM",
    "6:30 PM",
    "7:00 PM",
    "7:30 PM",
    "8:00 PM",
    "8:30 PM",
    "9:00 PM",
    "9:30 PM",
    "10:00 PM",
    "10:30 PM",
    "11:00 PM",
    "11:30 PM",
  ];

  return (
    <div className="relative w-28 ">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full text-left bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 
                   shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 
                   hover:border-gray-400 transition duration-200 flex justify-between items-center"
      >
        {value || "Select"}
        <span className="text-gray-500">{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div
          className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg 
                     max-h-48 overflow-y-auto"
        >
          {times.map((time) => (
            <button
              key={time}
              type="button"
              onClick={() => {
                onChange(time);
                setOpen(false);
              }}
              className={`block w-full text-left px-3 py-2 text-sm hover:bg-red-50 
                         ${
                           time === value
                             ? "text-red-600 font-semibold"
                             : "text-gray-700"
                         }`}
            >
              {time}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimeDropdown;
